import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings"

const fieldsConfig = {
    createTask : {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : true,
        options         : [true, false]
    },
    createProject : {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : true,
        options         : [true, false]
    },

    addProjectUsers : {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : false,
        options         : [true, false]
    },
}

export default class ProjectAccessStandardSettings extends ServerSettings {

    public createTask           : boolean
    public createProject        : boolean

    public addProjectUsers      : boolean

    constructor(config:any) {

        super(config, fieldsConfig)

        this.createTask         = this.initValue('createTask')
        this.createProject      = this.initValue('createProject')

        this.addProjectUsers    = this.initValue('addProjectUsers')
    }

    toJson() {
        const result = {}

        this.valueToJson(result, 'createTask')
        this.valueToJson(result, 'createProject')

        this.valueToJson(result, 'addProjectUsers')

        return result
    }
}